import axios from 'axios';

const API_URL_V3 = `${process.env.REACT_APP_REPORT_SERVER}/admin`;

class ReportService {

    getAllUsers() {
        return axios.get(`${API_URL_V3}/users`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi lấy danh sách người dùng", error);
                throw error;
            });
    }

    getAllReportsByUser() {
        return axios.get(`${API_URL_V3}/reports-by-user`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi lấy danh sách báo cáo:", error);
                throw error;
            });
    }

    /**
    * 📑 Lấy danh sách tất cả báo cáo lỗi theo người dùng
    * GET /admin/reports/handler
    */
    getAllReportsByAdmin() {
        return axios.get(`${API_URL_V3}/reports-by-admin`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi lấy danh sách báo cáo:", error);
                throw error;
            });
    }


    /**
     * 📊 Lấy chi tiết báo cáo
     * GET /admin/reports/:id
     */
    getReportDetails(id) {
        return axios.get(`${API_URL_V3}/reports/${id}`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi lấy chi tiết báo cáo:", error);
                throw error;
            });
    }

    /**
     * 🛠️ Cập nhật báo cáo lỗi (handledBy, status, adminNote)
     * PUT /admin/reports/:id/update
     */
    updateUserReport(id, formData) {
        return axios.put(`${API_URL_V3}/reports/${id}`, formData, {
            withCredentials: true
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi cập nhật báo cáo:", error);
                throw error;
            });
    }

    updateAdminReport(id, formData) {
        return axios.put(`${API_URL_V3}/reports/${id}`, formData, {
            withCredentials: true
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi cập nhật báo cáo:", error);
                throw error;
            });
    }


    /**
     * 📝 Admin trả lời báo cáo lỗi và cập nhật trạng thái
     * PUT /admin/reports/:id/reply
     */
    replyToReport(id, adminResponse, status) {
        const data = { adminResponse, status };

        return axios.put(`${API_URL_V3}/${id}/reply`, data, {
            withCredentials: true
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi trả lời báo cáo:", error);
                throw error;
            });
    }

    deleteReport(id) {
        return axios.delete(`${API_URL_V3}/reports/${id}`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi xóa báo cáo:", error);
                throw error;
            });
    }

    /**
     * 🤖 AI phân tích báo cáo lỗi và đề xuất phản hồi
     * POST /admin/reports/:id/ai-analyze
     * @param {string} reportId - ID báo cáo
     * @param {string|null} modelOverride - Model ID cụ thể (fine-tuned hoặc built-in), null = dùng mặc định
     */
    aiAnalyze(reportId, modelOverride = null) {
        return axios.post(`${API_URL_V3}/reports/${reportId}/ai-analyze`, 
            { modelOverride }, {
            withCredentials: true
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi phân tích AI:", error);
                throw error;
            });
    }

    /**
     * ✨ AI viết lại phản hồi từ ghi chú ngắn của admin
     * POST /admin/reports/:id/ai-rewrite
     */
    aiRewrite(reportId, adminNote, modelOverride = null) {
        return axios.post(`${API_URL_V3}/reports/${reportId}/ai-rewrite`,
            { adminNote, modelOverride }, {
            withCredentials: true
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi viết lại AI:", error);
                throw error;
            });
    }

    /**
     * 📚 Lấy danh sách training data
     * GET /admin/ai-training
     */
    getTrainingData(page = 1, limit = 20, toolName = '') {
        const params = { page, limit };
        if (toolName) params.toolName = toolName;
        return axios.get(`${API_URL_V3}/ai-training`, {
            withCredentials: true,
            params
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi lấy training data:", error);
                throw error;
            });
    }

    /**
     * 🗑️ Xóa training data
     * DELETE /admin/ai-training/:id
     */
    deleteTrainingData(id) {
        return axios.delete(`${API_URL_V3}/ai-training/${id}`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi xóa training data:", error);
                throw error;
            });
    }

    /**
     * 📥 Export training data thành JSONL
     * GET /admin/ai-training/export
     */
    exportTrainingJSONL() {
        return axios.get(`${API_URL_V3}/ai-training/export`, {
            withCredentials: true,
            responseType: 'blob'
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `training_data_${Date.now()}.jsonl`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(error => {
                console.error("Lỗi export JSONL:", error);
                throw error;
            });
    }


    /**
     * 📝 Người dùng tạo báo cáo lỗi với hình ảnh và tệp ZIP
     * POST /report
     */
    createReport(formData) {
        return axios.post(`${API_URL_V3}/reports`, formData, {
            withCredentials: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(response => response.data)
            .catch(error => {
                console.error("Lỗi khi tạo báo cáo lỗi:", error);
                throw error;
            });
    }

    /**
    * 🖼️ Tải ảnh đính kèm từ báo cáo lỗi
    * GET /admin/reports/image/:filename
    */
    downloadImage(filename) {
        return axios.get(`${API_URL_V3}/reports/image/${filename}`, {
            withCredentials: true,
            responseType: 'blob'
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                return url;
            })
            .catch(error => {
                console.error("Lỗi khi tải ảnh đính kèm:", error);
                throw error;
            });
    }

    /**
     * 📥 Admin tải tệp đính kèm từ báo cáo lỗi
     * GET /admin/reports/attachment/:filename
     */
    downloadAttachment(urlAttachment, stackTrace) {
        const filename = urlAttachment.split('/').pop();
        const ext = filename.split('.').pop();

        return axios.get(urlAttachment, {
            withCredentials: true,
            responseType: 'blob'
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${stackTrace}.${ext}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch(error => {
            console.error("Lỗi khi tải tệp đính kèm:", error);
            throw error;
        });
    }
}

export default new ReportService();
